import { actionSequence as apiActionSequence } from 'api/Api'
import {
  add as addChecklistItem
} from '../redux/checklistItems'
import {
  addItem as addItemToChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistId: number
  items: any[]
}

export default (payload: Payload) => async dispatch => {
  const { cardId, checklistId, items } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, [
    addChecklistItem({
      cardId,
      checklistItem: {
        id: tempId,
        name: '',
        isBusy: true
      }
    }),
    addItemToChecklist({
      elementId: checklistId,
      itemId: tempId,
      index: undefined
    })
  ])

  try {
    await apiActionSequence(
      items.map(item => ({
        method: 'AddChecklistItem',
        args: {
          checklistId,
          rtName: item.name
        }
      }))
    )
  } finally {
    optimisticAction.revert()
  }
}
